// extracted by mini-css-extract-plugin
var _1 = "BirdviewSparklineTooltip-moduletooltip__oP7tg Text-moduletext__Z2j5F";
export { _1 as "tooltip" }
